// extracted by mini-css-extract-plugin
export default {"chip":"SelectableUserTag_chip__okQWe"};